export class MystatsUI {
    QueueTime:string
    Yesterday:string
    Week:string 
    Month: string 
    Quater:string
}
